import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../../../../ui_kit/toggle/Toggle';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';

function FreeSample(props) {
  const {
    freeSample, uneditable, addFreeSample, removeFreeSample,
  } = props;

  return (
    <ClickableDiv
      className={`product-container ${!freeSample.eligible ? 'disabled' : ''}`}
      onClick={(!freeSample.selected && !uneditable) ? () => {
        addFreeSample(freeSample.id);
      } : undefined}
    >
      <div className="product-image">
        <img src={freeSample.product.image} alt={freeSample.product.name} />
      </div>
      <div className="product-content">
        <div className="product-title" dangerouslySetInnerHTML={{ __html: freeSample.product.name }} />
        <div className="product-variant">
          {freeSample.product.variant}
        </div>
        {freeSample.rules.min_order_amount && (
          <div className="rule">
            *Available on orders $
            {parseFloat(freeSample.rules.min_order_amount)}
            {' '}
            or more
          </div>
        )}
      </div>
      { !uneditable && (
        <div className="toggle-wrapper">
          <Toggle
            className="toggle"
            checked={freeSample.selected}
            onChange={() => {
              if (freeSample.selected) {
                removeFreeSample(freeSample.id);
              }
            }}
          />
        </div>
      )}
    </ClickableDiv>
  );
}

FreeSample.propTypes = {
  freeSample: PropTypes.shape({
    product: PropTypes.shape({
      image: PropTypes.string,
      name: PropTypes.string,
      variant: PropTypes.string,
    }),
    rules: PropTypes.shape({
      min_order_amount: PropTypes.string,
    }),
    eligible: PropTypes.bool,
    selected: PropTypes.bool,
  }).isRequired,
  addFreeSample: PropTypes.func.isRequired,
  removeFreeSample: PropTypes.func.isRequired,
  uneditable: PropTypes.bool,
};

export default FreeSample;
